var _clipPath, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 v30 h60 v-30 z",
    fill: "#00247d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L60,30 M60,0 L0,30",
    stroke: "#fff",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L60,30 M60,0 L0,30",
    clipPath: "url(#t)",
    stroke: "#cf142b",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30,0 v30 M0,15 h60",
    stroke: "#fff",
    strokeWidth: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30,0 v30 M0,15 h60",
    stroke: "#cf142b",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/gb.b89f53b0520c2590b408e4dcfb1cb646.svg";
export { ForwardRef as ReactComponent };